import { Component } from '@angular/core';
import { HelperService } from 'src/app/shared/helpers/helper.service';

@Component({
  selector: 'app-owner-terms-and-conditions',
  templateUrl: './owner-terms-and-conditions.component.html',
  styleUrl: './owner-terms-and-conditions.component.scss'
})
export class OwnerTermsAndConditionsComponent {

  constructor(public helperService: HelperService) {}

}
